import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { message } from "antd";
import moment from "moment";
import { sftpConnectionSchema } from "../../schema/sftp.schema";
// Connection Form element
import ConnectionFormElement from "../../components/SFTPConnector/ConnectionFormElement";

import Breadcrumb from "../../components/Breadcrumb";

import {
  useCreateConnection,
  useGetConnections,
  useUpdateConnection,
} from "../../hooks/sftp.hooks";

const CONNECTION = {
  connectionName: "",
  renameConnectionsName: undefined,
  connectionType: "SFTP",
  port: 22,
  host: "",
  retryTimes: 5,
  connectTimeout: 600000,
  disconnectTimeout: 600000,
  downloadZeroBytes: true,
  isPassive: true,
  forceIPv4: false,
  authType: undefined,
  username: undefined,
  password: "",
  privateKey: "",
  privateKeyPassword: "",
};

const ConnectionConfigurationForm = (props) => {
  // Mode Selection
  const [isAddMode, setIsAddMode] = useState(true);
  const [connectionID, setConnectionID] = useState(undefined);

  // Get sftp connection react query call

  const {
    isLoading: isLoadingSFTPData,
    data: SFTPConnectionsData,
    refetch: refetchSFTPConnectionsData,
  } = useGetConnections({
    select: (data) => {
      const updatedData = [...data];
      return updatedData.sort((a, b) => {
        return moment(b?.create_at).diff(a?.create_at);
      });
    },
  });

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    watch,
    resetField,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(sftpConnectionSchema),
    criteriaMode: "firstError",
    mode: "onChange",
    defaultValues: {
      connection: CONNECTION,
    },
  });

  // sftp job react query call Options
  const QueryOptions = {
    onSuccess: (dataResponce) => {
      message.success(dataResponce.message);
      reset();
      setIsAddMode(true);
      setConnectionID(undefined);
      refetchSFTPConnectionsData();
    },
    onError: (error) => {
      message.error(error.response.data.message);
    },
  };

  // Create sftp connection react query call
  const { mutate: mutateAdd } = useCreateConnection(QueryOptions);

  // Update sftp connection react query call
  const { mutate: mutateUpdate } = useUpdateConnection(QueryOptions);
  const onSubmit = (data) => {
    if (isAddMode === true) {
      mutateAdd(data?.connection);
    } else {
      let dataSet = {
        ...data?.connection,
      };
      dataSet.connectionName = dataSet.renameConnectionsName;
      mutateUpdate({ id: connectionID, data: dataSet });
    }
  };
  const onError = () => {
    message.error("Please Fill The Necessary Fields");
  };
  return (
    <div>
      <div className="container_aa">
        <h3>
          {isAddMode ? "Add " : "Edit "}
          SFTP Connections
        </h3>
        <Breadcrumb
          routes={[
            { path: "/", breadcrumbName: "Dashboard" },
            {
              path: "Connection Configuration",
              breadcrumbName: "Connection Configuration",
            },
          ]}
        />
      </div>
      <div className="container_ab">
        <div className="container_style_1_b" style={{ width: "100%" }}>
          <form onSubmit={handleSubmit(onSubmit, onError)}>
            <ConnectionFormElement
              control={control}
              Controller={Controller}
              errors={errors}
              setValue={setValue}
              watch={watch}
              SFTPConnectionsData={SFTPConnectionsData}
              isAddMode={isAddMode}
              setIsAddMode={setIsAddMode}
              setConnectionID={setConnectionID}
              resetField={resetField}
              clearErrors={clearErrors}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default ConnectionConfigurationForm;
